webpackJsonp([20],{

/***/ "0JNv":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ErU+");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7812d478", content, true);

/***/ }),

/***/ "ErU+":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".top-copy[data-v-677bb646]{margin-bottom:45px}ul[data-v-677bb646]{list-style-type:none;padding:0}ul li[data-v-677bb646]{margin-bottom:5px}ul li a[data-v-677bb646]{font-size:20px}", "", {"version":3,"sources":["/opt/build/repo/src/views/notices/notices.styl"],"names":[],"mappings":"AACA,2BACE,kBAAoB,CACrB,AACD,oBACE,qBAAsB,AACtB,SAAiB,CAClB,AACD,uBACE,iBAAmB,CACpB,AACD,yBACE,cAAgB,CACjB","file":"notices.styl","sourcesContent":["\n.top-copy[data-v-677bb646] {\n  margin-bottom: 45px;\n}\nul[data-v-677bb646] {\n  list-style-type: none;\n  padding: 0 0 0 0;\n}\nul li[data-v-677bb646] {\n  margin-bottom: 5px;\n}\nul li a[data-v-677bb646] {\n  font-size: 20px;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "jtnF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notices',
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ "sC6w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-wrap bg-dark"},[_c('div',{staticClass:"view-content bg-regular"},[_c('section',[_c('div',{staticClass:"section-inner"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"top-copy"},[_c('h1',[_vm._v("Legal Notices & Open Source Attribution")]),_vm._v(" "),_c('p',[_vm._v("RememBear utilizes the following open source projects:")])]),_vm._v(" "),_c('h3',[_vm._v("All Platforms")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://crates.io/crates/byteorder"}},[_vm._v("byteorder")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://crates.io/crates/diceware-gen"}},[_vm._v("diceware-gen")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://crates.io/crates/fast_chemail"}},[_vm._v("fast_chemail")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://crates.io/crates/lazy_static"}},[_vm._v("lazy-static")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://crates.io/crates/openssl"}},[_vm._v("openssl")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://crates.io/crates/openssl-sys"}},[_vm._v("openssl-sys")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://crates.io/crates/sodiumoxide"}},[_vm._v("sodiumoxide")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://crates.io/crates/zxcvbn"}},[_vm._v("zxcvbn")])])]),_vm._v(" "),_c('h3',[_vm._v("Windows")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/aspnet/EntityFramework6"}},[_vm._v("Microsoft EntityFramework6")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/bitstadium/HockeySDK-Windows"}},[_vm._v("Microsoft HockeySDK.WPF")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/dotnet/corefx"}},[_vm._v("Microsoft .NET CoreFX")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/unitycontainer"}},[_vm._v("Microsoft Unity")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"http://logging.apache.org/log4net/"}},[_vm._v("Apache log4net")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/higankanshi/Meta.Vlc"}},[_vm._v("Meta.Vlc")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"http://www.galasoft.ch/mvvm"}},[_vm._v("MvvmLight")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://developer.mozilla.org/en-US/docs/Mozilla/Projects/NSS"}},[_vm._v("NSS")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://www.newtonsoft.com/json"}},[_vm._v("Newtonsoft.Json")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"http://www.pdfsharp.net"}},[_vm._v("PDFsharp")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://system.data.sqlite.org/index.html/doc/trunk/www/index.wiki"}},[_vm._v("System.Data.SQLite")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/thomaslevesque/WeakEvent/"}},[_vm._v("ThomasLevesque.WeakEvent")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"http://sta.github.io/websocket-sharp/"}},[_vm._v("WebSocketSharp")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/Sascha-L/WPF-MediaKit"}},[_vm._v("WPFMediaKit")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/trichards57/zxcvbn-cs"}},[_vm._v("zxcvbn-cs")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/micjahn/ZXing.Net/"}},[_vm._v("ZXing.Net")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"http://wixtoolset.org/"}},[_vm._v("WiX Toolset")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://download.libsodium.org/doc/"}},[_vm._v("libsodium")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/moq/moq4"}},[_vm._v("Moq")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"http://www.castleproject.org/"}},[_vm._v("Castle.Core")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://fonts.google.com/specimen/Roboto+Mono"}},[_vm._v("Roboto Mono font")])])]),_vm._v(" "),_c('h3',[_vm._v("macOS")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/yaslab/CSV.swift"}},[_vm._v("CSV.swift")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://sparkle-project.org/"}},[_vm._v("Sparkle")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/potionfactory/LetsMove/"}},[_vm._v("LetsMove")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://try.crashlytics.com/"}},[_vm._v("crashlytics")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://get.fabric.io/"}},[_vm._v("fabric")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/zwopple/PocketSocket"}},[_vm._v("PocketSocket")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/PerfectlySoft/Perfect-HTTP"}},[_vm._v("Perfect-HTTP")])])]),_vm._v(" "),_c('h3',[_vm._v("iOS")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/FredericJacobs/OpenSSL-Pod"}},[_vm._v("OpenSSL")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/SVProgressHUD/SVProgressHUD"}},[_vm._v("SVProgressHUD")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/jverdi/JVFloatLabeledTextField"}},[_vm._v("JVFloatLabeledTextField")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/John-Lluch/SWRevealViewController"}},[_vm._v("SWRevealViewController")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/davbeck/TUSafariActivity"}},[_vm._v("TUSafariActivity")])])]),_vm._v(" "),_c('h3',[_vm._v("macOS/iOS")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/Thomvis/BrightFutures"}},[_vm._v("BrightFutures")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/antitypical/Result"}},[_vm._v("Result")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/ccgus/fmdb"}},[_vm._v("FMDB")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://libsodium.org"}},[_vm._v("Libsodium")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/malcommac/SwiftDate"}},[_vm._v("SwiftDate")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/Swinject/Swinject"}},[_vm._v("Swinject")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/DaveWoodCom/XCGLogger"}},[_vm._v("XCGLogger")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/marmelroy/Zip"}},[_vm._v("Zip")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/samuelwford/swfsemanticversion"}},[_vm._v("SWFSemanticVersion")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/evgenyneu/keychain-swift"}},[_vm._v("KeychainSwift")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/dropbox/zxcvbn-ios"}},[_vm._v("zxcvbn-ios")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://fonts.google.com/specimen/Roboto+Mono"}},[_vm._v("Roboto Mono font")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://www.zetetic.net/sqlcipher/"}},[_vm._v("SQLCipher")])])]),_vm._v(" "),_c('h3',[_vm._v("Android")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"target":"_blank","href":"http://jakewharton.github.io/butterknife/"}},[_vm._v("Butter Knife")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://google.github.io/dagger/"}},[_vm._v("Dagger")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"http://facebook.github.io/rebound/"}},[_vm._v("Facebook Rebound")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/mozilla-mobile/focus-android"}},[_vm._v("Firefox Focus")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"http://square.github.io/okhttp/"}},[_vm._v("OkHttp")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://www.guardsquare.com/en/proguard"}},[_vm._v("ProGuard")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"http://square.github.io/retrofit/"}},[_vm._v("Retrofit")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/ReactiveX/RxJava"}},[_vm._v("RxJava")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://www.zetetic.net/sqlcipher/"}},[_vm._v("SQLCipher")])])]),_vm._v(" "),_c('h3',[_vm._v("Website")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://webpack.js.org/"}},[_vm._v("Webpack")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://babeljs.io/"}},[_vm._v("Babel")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://www.npmjs.com/"}},[_vm._v("NPM")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://vuejs.org/"}},[_vm._v("VueJS")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://vuex.vuejs.org/"}},[_vm._v("Vuex")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://router.vuejs.org/"}},[_vm._v("vue-router")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/axios/axios"}},[_vm._v("Axios")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://github.com/js-cookie/js-cookie"}},[_vm._v("js-cookie")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"http://stylus-lang.com/"}},[_vm._v("Stylus")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tGQv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notices_vue__ = __webpack_require__("jtnF");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_677bb646_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notices_vue__ = __webpack_require__("sC6w");
function injectStyle (ssrContext) {
  __webpack_require__("0JNv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-677bb646"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_677bb646_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/20.b3440354886632551e41.js